// extracted by mini-css-extract-plugin
export default {"colorRed":"globals_colorRed__wIUPx"};